module.exports = __webpack_public_path__ + "static/media/basketball.1f55b18f.svg";